import { createContext, useContext, useEffect, useState } from "react";
import { fetchProducts } from "@/lib/shop";

const ShopContext = createContext(null);

export const ShopProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const list = await fetchProducts(null, 50);
        setProducts(list);
      } catch {
        /* ignore */
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getByHandle = (handle) => products.find((p) => p.handle === handle);

  return (
    <ShopContext.Provider value={{ products, loading, getByHandle }}>
      {children}
    </ShopContext.Provider>
  );
};

export const useShop = () => {
  const ctx = useContext(ShopContext);
  if (!ctx) throw new Error("useShop must be used within ShopProvider");
  return ctx;
};
